import React from 'react';
import OptImage from '../utils/OptImage';

const OurExperts = () => {
  const experts = [
    {
      id: 1,
      name: "Dr. Deepika Sinha",
      qualifications: "MBBS(LHMC, Delhi), MS Surgery (MAMC, Delhi), MCh (PGI Raipur) and MRCS (Glasgow, UK)",
      experience: "Expert in Plastic, Reconstructive & Cosmetic Surgery",
      specialties: "Specialized in advanced aesthetic procedures, facial rejuvenation, body contouring, and reconstructive surgery. Committed to delivering natural-looking results with the highest standards of patient care.",
      image: "profile-image_qratnq"
    }
  ];

  return (
    <section className="our-experts">
      <div className="container">
        <div className="experts-header">
          <h2 className="section-title">Meet Our Expert</h2>
        </div>
        <div className="experts-grid">
          {experts.map(expert => (
            <div key={expert.id} className="expert-card">
              <div className="expert-image">
                <OptImage src={expert.image} alt={expert.name} />
              </div>
              <div className="expert-info">
                <h3 className="expert-name">{expert.name}</h3>
                <p className="expert-qualifications">{expert.qualifications}</p>
                <p className="expert-experience">{expert.experience}</p>
                <p className="expert-specialties">{expert.specialties}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OurExperts;